import { useClearQueryCacheOnDistrictChange } from './useClearQueryCacheOnDistrictChange'
import { useClearQueryCacheOnUserChange } from './useClearQueryCacheOnUserChange'

/**
 * Clears the TanStack Query cache when the signed-in user or the active
 * district changes, so a second account on the same browser never sees the
 * first account's cached data.
 *
 * Rendered by the app root as a sibling of the routes, inside both
 * `AuthProvider` (from `@wehunt/core-web`) and `QueryClientProvider`, which is
 * what the two hooks need. This used to live inside Viltrapport's own
 * AuthProvider; when that provider was replaced by core-web's, the effects
 * would have silently disappeared with it, so they are a component of their
 * own now, mounted explicitly.
 */
export function CacheIsolationEffect() {
  useClearQueryCacheOnUserChange()
  useClearQueryCacheOnDistrictChange()
  return null
}
